"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _chatComposer = require("@common/components/chat-composer/chat-composer");
var _chatComposerAddMenu = require("@common/components/chat-composer/chat-composer-add-menu");
var _chatComposerImagePreview = require("@common/components/chat-composer/chat-composer-image-preview");
var _react2 = require("@tiptap/react");
var _extensionMention = _interopRequireDefault(require("@tiptap/extension-mention"));
var _extensionDocument = _interopRequireDefault(require("@tiptap/extension-document"));
var _chatAttachmentPaste = require("@common/utils/chat-attachment-paste");
var _extensionParagraph = _interopRequireDefault(require("@tiptap/extension-paragraph"));
var _extensionText = _interopRequireDefault(require("@tiptap/extension-text"));
var _extensionHardBreak = _interopRequireDefault(require("@tiptap/extension-hard-break"));
var _extensions = require("@tiptap/extensions");
var _command = require("@design/ui/command");
var _popover = require("@design/ui/popover");
var _useDioptraFetch2 = require("../hooks/use-dioptra-fetch");
var _useOrgFeatureFlag = _interopRequireDefault(require("../hooks/useOrgFeatureFlag"));
var _AnalyticsContext = require("../context/AnalyticsContext");
var _envManager = require("../utils/envManager");
var _AuthContext = require("../context/AuthContext");
var _ChatContext = require("../context/ChatContext");
var _tiptapEditor = require("../utils/tiptap-editor");
var _tiptapParagraphs = require("@common/utils/tiptap-paragraphs");
var _useImprovePrompt = require("../hooks/useImprovePrompt");
var _attachPastChatsSheet = require("@common/components/chat-composer/sheets/attach-past-chats-sheet");
var _customizeAgentSheet = require("@common/components/chat-composer/sheets/customize-agent-sheet");
var _ChatArtifactsSheet = require("./chat/sheets/ChatArtifactsSheet");
var _SelectWorkspaceSheet = require("./chat/sheets/SelectWorkspaceSheet");
var _analytics = require("@common/analytics");
var _useConversationProject = require("../hooks/useConversationProject");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _api = require("../utils/api");
var _ChatInput = require("./ChatInput.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TURN_NOT_YET_PERSISTED_STATUS = 404;
var NO_SENT_FILE_IDS = new Set();
var MENU_KEYS_HANDLED_BY_COMMAND = new Set(['ArrowUp', 'ArrowDown', 'Enter']);
var MENTION_EMPTY_LABEL = {
  tag: 'No tags found',
  tool: 'No tools found'
};
var MentionSuggestionMenu = function MentionSuggestionMenu(_ref) {
  var menu = _ref.menu,
    commandRef = _ref.commandRef,
    onDismiss = _ref.onDismiss;
  var caretAnchor = {
    current: {
      getBoundingClientRect: function getBoundingClientRect() {
        var _menu$clientRect, _menu$clientRect2;
        return (_menu$clientRect = (_menu$clientRect2 = menu.clientRect) === null || _menu$clientRect2 === void 0 ? void 0 : _menu$clientRect2.call(menu)) !== null && _menu$clientRect !== void 0 ? _menu$clientRect : new DOMRect();
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_popover.Popover, {
    open: true,
    onOpenChange: function onOpenChange(open) {
      return open || onDismiss();
    },
    "data-sentry-element": "Popover",
    "data-sentry-component": "MentionSuggestionMenu",
    "data-sentry-source-file": "ChatInput.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverAnchor, {
      virtualRef: caretAnchor,
      "data-sentry-element": "PopoverAnchor",
      "data-sentry-source-file": "ChatInput.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, {
      side: "top",
      align: "start",
      sideOffset: 8,
      onOpenAutoFocus: function onOpenAutoFocus(event) {
        return event.preventDefault();
      },
      onCloseAutoFocus: function onCloseAutoFocus(event) {
        return event.preventDefault();
      },
      "data-sentry-element": "PopoverContent",
      "data-sentry-source-file": "ChatInput.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.Command, {
        ref: commandRef,
        shouldFilter: false,
        "data-sentry-element": "Command",
        "data-sentry-source-file": "ChatInput.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandList, {
          label: menu.kind === 'tag' ? 'Tags' : 'Tools',
          "data-sentry-element": "CommandList",
          "data-sentry-source-file": "ChatInput.tsx",
          children: [menu.items.map(function (item) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandItem, {
              value: item.id,
              onSelect: function onSelect() {
                return menu.command({
                  id: item.id,
                  label: item.name
                });
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "flex min-w-0 flex-col",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "fit-truncate text-label",
                  children: item.name
                }), item.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "fit-wrap text-caption text-muted-foreground",
                  children: item.description
                })]
              })
            }, item.id);
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandEmpty, {
            "data-sentry-element": "CommandEmpty",
            "data-sentry-source-file": "ChatInput.tsx",
            children: MENTION_EMPTY_LABEL[menu.kind]
          })]
        })
      })
    })]
  });
};

// Tool hints for the agent - these map to actual agent tools
var TOOL_HINTS = [{
  id: 'web_search',
  name: 'Search the Web',
  description: 'Search for information online using Perplexity',
  keywords: ['search', 'web', 'online', 'perplexity', 'internet']
}, {
  id: 'redline_section',
  name: 'Edit Document',
  description: 'Make changes to specific sections of the document',
  keywords: ['edit', 'redline', 'modify', 'change', 'revise']
}, {
  id: 'add_comment',
  name: 'Add Comment',
  description: 'Add comments to explain changes or provide feedback',
  keywords: ['comment', 'note', 'feedback', 'explain']
}, {
  id: 'add_paragraph',
  name: 'Add Paragraph',
  description: 'Insert new paragraphs into the document',
  keywords: ['add', 'insert', 'paragraph', 'new']
}, {
  id: 'search_memories',
  name: 'Search Memories',
  description: 'Search through saved conversation memories',
  keywords: ['search', 'memory', 'memories', 'recall', 'find']
}, {
  id: 'save_memory',
  name: 'Save Memory',
  description: 'Remember important information from this conversation',
  keywords: ['save', 'remember', 'memory', 'store', 'recall', 'memorize']
}, {
  id: 'generate_files',
  name: 'Generate Files',
  description: 'Create Word, PowerPoint, or Excel files',
  keywords: ['generate', 'create', 'file', 'document', 'powerpoint', 'excel', 'word']
}, {
  id: 'guideline_suggestion',
  name: 'Suggest Guidelines',
  description: 'Create reusable playbook rules',
  keywords: ['guideline', 'rule', 'playbook', 'suggest', 'recommendation']
}, {
  id: 'sub_agent',
  name: 'Use Sub-Agent',
  description: 'Use a sub-agent to perform a task',
  keywords: ['sub-agent', 'sub agent', 'agent']
}];
var ChatInputComponent = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _project$name, _improve$improveError;
  var onSubmit = _ref2.onSubmit,
    greeting = _ref2.greeting,
    selectedModel = _ref2.selectedModel,
    onModelChange = _ref2.onModelChange,
    onOpenLibrary = _ref2.onOpenLibrary,
    onAgentSettingsSaved = _ref2.onAgentSettingsSaved,
    onOpenHistory = _ref2.onOpenHistory,
    onNewConversation = _ref2.onNewConversation,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? "What would you like to know?" : _ref2$placeholder,
    onRemoveFiles = _ref2.onRemoveFiles,
    _ref2$selectedFiles = _ref2.selectedFiles,
    selectedFiles = _ref2$selectedFiles === void 0 ? [] : _ref2$selectedFiles,
    _ref2$sentFileIds = _ref2.sentFileIds,
    sentFileIds = _ref2$sentFileIds === void 0 ? NO_SENT_FILE_IDS : _ref2$sentFileIds,
    _ref2$loadingFiles = _ref2.loadingFiles,
    loadingFiles = _ref2$loadingFiles === void 0 ? new Set() : _ref2$loadingFiles,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    onOpenFilesPanel = _ref2.onOpenFilesPanel,
    onAttachConversation = _ref2.onAttachConversation,
    _ref2$attachedConvers = _ref2.attachedConversations,
    attachedConversations = _ref2$attachedConvers === void 0 ? [] : _ref2$attachedConvers,
    onRemoveConversation = _ref2.onRemoveConversation,
    _ref2$isGenerating = _ref2.isGenerating,
    isGenerating = _ref2$isGenerating === void 0 ? false : _ref2$isGenerating,
    _ref2$isLoading = _ref2.isLoading,
    isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
    conversationId = _ref2.conversationId,
    onInterrupt = _ref2.onInterrupt,
    onFilesPasted = _ref2.onFilesPasted;
  var isWebSearchDisabled = (0, _useOrgFeatureFlag.default)('is_web_search_disabled');
  var _useConversationProje = (0, _useConversationProject.useConversationProject)(conversationId),
    project = _useConversationProje.project,
    attach = _useConversationProje.attach;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    openSheet = _useState2[0],
    setOpenSheet = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSkills = _useState4[0],
    setSelectedSkills = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    mentionMenu = _useState6[0],
    setMentionMenu = _useState6[1];
  var mentionCommandRef = (0, _react.useRef)(null);
  var isSuggestionActive = mentionMenu !== null;
  var _useChat = (0, _ChatContext.useChat)(),
    getChatInputDraft = _useChat.getChatInputDraft,
    setChatInputDraft = _useChat.setChatInputDraft,
    artifacts = _useChat.artifacts,
    selectedConversation = _useChat.selectedConversation,
    plusButtonHasArtifactDot = _useChat.plusButtonHasArtifactDot,
    plusButtonArtifactDotFlashing = _useChat.plusButtonArtifactDotFlashing,
    chatArtifactsMenuItemHasArtifactDot = _useChat.chatArtifactsMenuItemHasArtifactDot,
    notifyAddMenuOpen = _useChat.notifyAddMenuOpen;
  var _useState7 = (0, _react.useState)(function () {
      return getChatInputDraft();
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    internalValue = _useState8[0],
    setInternalValue = _useState8[1];
  var internalValueRef = (0, _react.useRef)(internalValue);
  (0, _react.useEffect)(function () {
    return function () {
      setChatInputDraft(internalValueRef.current);
    };
  }, [setChatInputDraft, internalValueRef]);
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError,
    analytics = _useAnalytics.analytics;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var onFilesPastedRef = (0, _react.useRef)(onFilesPasted);
  onFilesPastedRef.current = onFilesPasted;
  var mentionMenuRenderer = function mentionMenuRenderer(kind) {
    return function () {
      var showMentionMenu = function showMentionMenu(props) {
        return setMentionMenu({
          kind: kind,
          items: props.items,
          command: props.command,
          clientRect: props.clientRect
        });
      };
      return {
        onStart: showMentionMenu,
        onUpdate: showMentionMenu,
        onKeyDown: function onKeyDown(_ref3) {
          var event = _ref3.event;
          if (event.key === 'Escape') {
            setMentionMenu(null);
            return true;
          }
          var commandRoot = mentionCommandRef.current;
          if (!commandRoot || !MENU_KEYS_HANDLED_BY_COMMAND.has(event.key)) return false;
          commandRoot.dispatchEvent(new KeyboardEvent('keydown', {
            key: event.key,
            bubbles: true,
            cancelable: true
          }));
          return true;
        },
        onExit: function onExit() {
          return setMentionMenu(null);
        }
      };
    };
  };
  var editor = (0, _react2.useEditor)({
    extensions: [_extensionDocument.default, _extensionParagraph.default, _extensionText.default, _extensionHardBreak.default, _extensions.UndoRedo.configure({
      depth: 100
    }), _extensions.Placeholder.configure({
      placeholder: placeholder
    }), (0, _chatAttachmentPaste.composerFilePasteExtension)(function () {
      return onFilesPastedRef.current;
    }), _extensionMention.default.configure({
      HTMLAttributes: {
        class: 'mention'
      },
      suggestion: {
        char: '#',
        allowSpaces: true,
        render: mentionMenuRenderer('tag'),
        items: function () {
          var _items = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4) {
            var query, response, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  query = _ref4.query;
                  _context.p = 1;
                  _context.n = 2;
                  return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/tags?search=").concat(encodeURIComponent(query), "&limit=10"));
                case 2:
                  response = _context.v;
                  return _context.a(2, response.tags || []);
                case 3:
                  _context.p = 3;
                  _t = _context.v;
                  console.error('Error fetching tags:', _t);
                  sendError(_t, {
                    component: 'ChatInput',
                    action: 'fetch_tags',
                    query: query
                  });
                  return _context.a(2, []);
              }
            }, _callee, null, [[1, 3]]);
          }));
          function items(_x) {
            return _items.apply(this, arguments);
          }
          return items;
        }()
      }
    }), _extensionMention.default.extend({
      name: 'toolMention'
    }).configure({
      HTMLAttributes: {
        class: 'tool-mention'
      },
      suggestion: {
        char: '@',
        allowSpaces: true,
        render: mentionMenuRenderer('tool'),
        items: function items(_ref5) {
          var query = _ref5.query;
          var availableHints = isWebSearchDisabled ? TOOL_HINTS.filter(function (tool) {
            return tool.id !== 'web_search';
          }) : TOOL_HINTS;
          return availableHints.filter(function (tool) {
            return (0, _foldedTextSearch.matchesSearch)(tool.name, query) || (0, _foldedTextSearch.matchesSearch)(tool.description, query) || tool.keywords.some(function (keyword) {
              return (0, _foldedTextSearch.matchesSearch)(keyword, query);
            });
          });
        }
      }
    })],
    content: {
      type: "doc",
      content: (0, _tiptapParagraphs.editorTextToParagraphNodes)(getChatInputDraft())
    },
    onUpdate: function onUpdate(_ref6) {
      var editor = _ref6.editor;
      // Track text locally only — no parent re-render per keystroke
      var text = editor.getText();
      setInternalValue(text);
      internalValueRef.current = text;
      var mentionedSkills = [];
      editor.state.doc.descendants(function (node) {
        if (node.type.name === 'toolMention') {
          var toolName = node.attrs.label;
          if (toolName) {
            mentionedSkills.push(toolName);
          }
        }
      });
      setSelectedSkills(function (prevSkills) {
        var dropdownOnlySkills = prevSkills.filter(function (skill) {
          return !mentionedSkills.includes(skill);
        });
        var combinedSkills = _toConsumableArray(new Set([].concat(_toConsumableArray(dropdownOnlySkills), mentionedSkills)));
        return combinedSkills;
      });
    },
    editorProps: {
      attributes: {
        class: 'outline-none'
      },
      handlePaste: (0, _tiptapParagraphs.plainTextPasteHandler)(function () {
        return editor;
      }),
      handleKeyDown: function handleKeyDown(_view, event) {
        if (event.ctrlKey || event.metaKey) {
          if (event.key === 'z' || event.key === 'Z') {
            event.preventDefault();
            if (event.shiftKey) {
              editor === null || editor === void 0 || editor.chain().focus().redo().run();
            } else {
              editor === null || editor === void 0 || editor.chain().focus().undo().run();
            }
            return true;
          }
        }
        if (event.key === 'Enter') {
          if (event.shiftKey) {
            event.preventDefault();
            if (editor) {
              editor.chain().focus().setHardBreak().run();
            }
            return true;
          } else {
            event.preventDefault();

            // Don't submit if suggestion is active - let suggestion handle it
            if (isSuggestionActive) {
              return false;
            }

            // Don't submit if currently generating - user must click button to interrupt
            if (isGenerating) {
              return true;
            }

            // Don't submit while we're waiting on the post-history-select
            // poll either: we don't yet know whether an agent is still
            // running on this conversation, and firing a parallel send
            // would interleave with it.
            if (isLoading) {
              return true;
            }
            handleSubmit();
            return true;
          }
        }
        return false;
      }
    }
  });
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        editor === null || editor === void 0 || editor.commands.focus();
      },
      insertValue: function insertValue(value) {
        if (!editor) {
          return;
        }
        (0, _tiptapEditor.appendTextAsParagraphs)(editor, value);
        setInternalValue(editor.getText());
      }
    };
  }, [editor]);
  var improve = (0, _useImprovePrompt.useImprovePrompt)({
    draft: internalValue,
    attachments: selectedFiles.map(function (file) {
      return "fileName" in file ? file.fileName : file.name;
    }),
    selectedSkills: selectedSkills,
    fillComposer: function fillComposer(text) {
      if (!editor || internalValueRef.current !== internalValue) {
        return null;
      }
      (0, _tiptapEditor.replaceTextAsParagraphs)(editor, text);
      return editor.getText();
    }
  });
  (0, _react.useEffect)(function () {
    improve.syncDraft(internalValue);
  }, [internalValue, improve.syncDraft]);
  var handleSubmit = function handleSubmit() {
    if (disabled) {
      return;
    }
    onSubmit(internalValue, selectedSkills.length > 0 ? selectedSkills : undefined);

    // onUpdate syncs internalValue after clearing
    if (editor) {
      editor.commands.clearContent();
    }
    setChatInputDraft("");
  };
  var handleInterrupt = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var status, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!(!conversationId || !authHeader)) {
              _context2.n = 1;
              break;
            }
            console.error('Cannot interrupt: missing conversation ID or auth header');
            return _context2.a(2);
          case 1:
            _context2.p = 1;
            _context2.n = 2;
            return (0, _api.interruptAgentChat)(authHeader, conversationId);
          case 2:
            onInterrupt === null || onInterrupt === void 0 || onInterrupt();
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            console.error('Failed to interrupt conversation:', _t2);
            status = _t2 === null || _t2 === void 0 ? void 0 : _t2.status;
            sendError(_t2, {
              component: 'ChatInput',
              action: 'interrupt_conversation',
              conversationId: conversationId,
              level: status === TURN_NOT_YET_PERSISTED_STATUS ? "warning" : "error"
            });
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function handleInterrupt() {
      return _ref7.apply(this, arguments);
    };
  }();
  var getFileName = function getFileName(file) {
    return 'name' in file ? file.name : file.fileName;
  };
  var isNewConversation = greeting !== null;
  var isDraftUnsendable = disabled || internalValue.trim().length === 0;
  function sendState() {
    if (isLoading) return "loading";
    if (isGenerating) return "busy";
    return isDraftUnsendable ? "empty" : "ready";
  }
  function magicPromptState() {
    if (improve.improveState === "improving") return "improving";
    return isDraftUnsendable ? "empty" : "ready";
  }
  var conversationAttachments = attachedConversations.map(function (conversation) {
    return {
      id: conversation.id,
      kind: "past-chat",
      name: conversation.name,
      isLoading: false,
      imagePreview: null,
      onRemove: function onRemove() {
        return onRemoveConversation(conversation.id);
      }
    };
  });
  var fileAttachments = selectedFiles.flatMap(function (file, index) {
    if ("id" in file && sentFileIds.has(file.id)) return [];
    var fileName = getFileName(file);
    return [{
      id: fileName,
      kind: "document",
      name: fileName,
      isLoading: loadingFiles.has(fileName),
      imagePreview: "fileName" in file ? (0, _chatComposerImagePreview.attachmentImagePreview)(fileName, file.storageUrl) : null,
      onRemove: function onRemove() {
        return onRemoveFiles(index);
      }
    }];
  });
  var pendingFileAttachments = Array.from(loadingFiles).filter(function (fileName) {
    return !selectedFiles.some(function (file) {
      return getFileName(file) === fileName;
    });
  }).map(function (fileName) {
    return {
      id: fileName,
      kind: "document",
      name: fileName,
      isLoading: true,
      imagePreview: null,
      onRemove: null
    };
  });
  var composerAnalytics = {
    sink: analytics,
    surface: "word-addin",
    conversationId: conversationId || null
  };
  var workspace = {
    label: (_project$name = project === null || project === void 0 ? void 0 : project.name) !== null && _project$name !== void 0 ? _project$name : null,
    isDisabled: !conversationId,
    onOpen: function onOpen() {
      return setOpenSheet("workspace");
    }
  };
  function handleAgentSettingsSaved() {
    return _handleAgentSettingsSaved.apply(this, arguments);
  }
  function _handleAgentSettingsSaved() {
    _handleAgentSettingsSaved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return onAgentSettingsSaved();
          case 1:
            (0, _analytics.trackChatComposerEvent)(composerAnalytics, {
              name: "chat_composer_agent_settings_saved"
            });
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _handleAgentSettingsSaved.apply(this, arguments);
  }
  function handleModelChange(model) {
    onModelChange(model);
    (0, _analytics.trackChatComposerEvent)(composerAnalytics, {
      name: "chat_composer_model_selected",
      model: model
    });
  }
  var artifactDot = plusButtonHasArtifactDot ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatInput.PlusButtonDot, {
    $flashing: plusButtonArtifactDotFlashing
  }) : null;
  var chatArtifactsEntry = artifacts.length > 0 ? {
    hasNewArtifact: chatArtifactsMenuItemHasArtifactDot,
    onOpen: function onOpen() {
      return setOpenSheet("chat-artifacts");
    }
  } : null;
  var addMenu = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "relative inline-flex",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_chatComposerAddMenu.ChatComposerAddMenu, {
      menuSide: isNewConversation ? "bottom" : "top",
      chatArtifacts: chatArtifactsEntry,
      onMenuOpen: notifyAddMenuOpen,
      onAttachFile: onOpenFilesPanel,
      pastChats: {
        kind: "sheet",
        onOpen: function onOpen() {
          return setOpenSheet("past-chats");
        }
      },
      onOpenLibrary: onOpenLibrary,
      onNewConversation: isNewConversation ? null : onNewConversation,
      customizeAgent: {
        kind: "sheet",
        onOpen: function onOpen() {
          return setOpenSheet("customize-agent");
        }
      },
      model: null,
      onOpenChatHistory: onOpenHistory,
      analytics: composerAnalytics
    }), artifactDot]
  });
  function renderOpenSheet() {
    var closeSheet = function closeSheet() {
      return setOpenSheet(null);
    };
    if (openSheet === "workspace") {
      var _selectedConversation;
      var startedChatName = isNewConversation ? null : (_selectedConversation = selectedConversation === null || selectedConversation === void 0 ? void 0 : selectedConversation.name) !== null && _selectedConversation !== void 0 ? _selectedConversation : null;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectWorkspaceSheet.SelectWorkspaceSheet, {
        onClose: closeSheet,
        project: project,
        attach: attach,
        chatName: startedChatName
      });
    }
    if (openSheet === "past-chats") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_attachPastChatsSheet.AttachPastChatsSheet, {
        onClose: closeSheet,
        excludeConversationId: conversationId || null,
        attachedConversationIds: attachedConversations.map(function (conversation) {
          return conversation.id;
        }),
        onAttachConversation: onAttachConversation
      });
    }
    if (openSheet === "chat-artifacts") return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatArtifactsSheet.ChatArtifactsSheet, {
      onClose: closeSheet
    });
    if (openSheet === "customize-agent") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_customizeAgentSheet.CustomizeAgentSheet, {
        onClose: closeSheet,
        model: {
          value: selectedModel,
          onChange: handleModelChange
        },
        onSaved: handleAgentSettingsSaved
      });
    }
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: isNewConversation ? "grid flex-1 content-center justify-items-center" : undefined,
    children: [mentionMenu && /*#__PURE__*/(0, _jsxRuntime.jsx)(MentionSuggestionMenu, {
      menu: mentionMenu,
      commandRef: mentionCommandRef,
      onDismiss: function onDismiss() {
        return setMentionMenu(null);
      }
    }), (improve.nudge || improve.improveError) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": "improve-nudge",
      style: {
        fontSize: 11,
        marginBottom: 6,
        color: improve.improveError ? "#c53030" : "#5a6b85"
      },
      children: (_improve$improveError = improve.improveError) !== null && _improve$improveError !== void 0 ? _improve$improveError : improve.nudge
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatComposer.ChatComposer, {
      surface: "addin",
      greeting: greeting,
      editor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatInput.EditorContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.EditorContent, {
          editor: editor
        })
      }),
      editorInstance: editor,
      contextAttachments: [].concat(_toConsumableArray(conversationAttachments), _toConsumableArray(fileAttachments), _toConsumableArray(pendingFileAttachments)),
      addMenu: addMenu,
      workspace: workspace,
      secondaryActions: null,
      sendState: sendState(),
      onSend: handleSubmit,
      onStop: handleInterrupt,
      magicPrompt: {
        state: magicPromptState(),
        onImprove: improve.improveDraft
      },
      onVoiceInput: null
    }), renderOpenSheet()]
  });
});
ChatInputComponent.displayName = 'ChatInput';
var fileKey = function fileKey(f) {
  return "name" in f ? f.name : f.fileName;
};
var areChatInputPropsEqual = function areChatInputPropsEqual(prevProps, nextProps) {
  if (prevProps.disabled !== nextProps.disabled || prevProps.placeholder !== nextProps.placeholder || prevProps.isGenerating !== nextProps.isGenerating || prevProps.isLoading !== nextProps.isLoading || prevProps.conversationId !== nextProps.conversationId || prevProps.greeting !== nextProps.greeting || prevProps.selectedModel !== nextProps.selectedModel) {
    return false;
  }

  // Compare function props to avoid stale handlers
  if (prevProps.onSubmit !== nextProps.onSubmit || prevProps.onModelChange !== nextProps.onModelChange || prevProps.onOpenLibrary !== nextProps.onOpenLibrary || prevProps.onAgentSettingsSaved !== nextProps.onAgentSettingsSaved || prevProps.onOpenHistory !== nextProps.onOpenHistory || prevProps.onNewConversation !== nextProps.onNewConversation || prevProps.onOpenFilesPanel !== nextProps.onOpenFilesPanel || prevProps.onRemoveFiles !== nextProps.onRemoveFiles || prevProps.onFilesPasted !== nextProps.onFilesPasted || prevProps.onInterrupt !== nextProps.onInterrupt || prevProps.onAttachConversation !== nextProps.onAttachConversation || prevProps.onRemoveConversation !== nextProps.onRemoveConversation) {
    return false;
  }
  var prevFilesKey = (prevProps.selectedFiles || []).map(fileKey).join("|");
  var nextFilesKey = (nextProps.selectedFiles || []).map(fileKey).join("|");
  if (prevFilesKey !== nextFilesKey) return false;
  var prevSentKey = Array.from(prevProps.sentFileIds || []).sort().join("|");
  var nextSentKey = Array.from(nextProps.sentFileIds || []).sort().join("|");
  if (prevSentKey !== nextSentKey) return false;
  var prevConvsKey = (prevProps.attachedConversations || []).map(function (c) {
    return c.id;
  }).join("|");
  var nextConvsKey = (nextProps.attachedConversations || []).map(function (c) {
    return c.id;
  }).join("|");
  if (prevConvsKey !== nextConvsKey) return false;
  var prevLoadingKey = JSON.stringify(Array.from(prevProps.loadingFiles || new Set()).sort());
  var nextLoadingKey = JSON.stringify(Array.from(nextProps.loadingFiles || new Set()).sort());
  if (prevLoadingKey !== nextLoadingKey) return false;
  return true;
};
var ChatInput = exports.ChatInput = /*#__PURE__*/_react.default.memo(ChatInputComponent, areChatInputPropsEqual);